export const translation = {
    'ru': {
        'Depository': 'Депозитарий',
        'Deposit from my Wallet': 'Депозит из моего кошелька',
        'Deposit from another Depository': 'Перевод от другого участника',
        'Withdraw to my Wallet': 'Вывести на мой кошелек',
        'Send to another Depository': 'Отправить другому участнику',
        'Buy CPT': 'Купить CPT',
        'Depository is': 'Депозитарий',
        'Depository is internal Cryptaur': ' - специальный счет в системе Cryptaur, позволяющий без комиссий оплачивать товары и услуги внутри экосистемы, обмениваться токенами с другими участниками, а также получать вознаграждения и бонусы.',
        'Payments in app': 'Каждая транзакция фиксируется в Cryptaur Blockchain',
        'Transactions do not reflect': 'Пополнение депозитария с баланса вашего Кошелька и вывод токенов обратно на Кошелек требует оплаты транзакции в сети Ethereum.',
        'History': 'История',
        'Show all transactions': 'Все транзакции',
        'Enter two-factor': 'Введите код двухфакторной аутентификации',
        'Deposit': 'Депозит',
        'Is in your wallet': 'В вашем кошельке',
        'Maximum amount available for deposit': 'Максимальная сумма, доступная для депозита',
        'The cost per transaction': 'Стоимость транзакции',
        'You have': 'У вас есть',
        'ETH in your wallet': 'ETH на вашем кошельке',
        'Send the address': 'Чтобы получить перевод, сообщите ваш номер счета отправителю.',
        'He or she needs': 'Сообщите отправителю, что перевод на этот номер возможен только через вкладку Депозитарий личного кабинета!',
        'Transfers between depositories without commission': 'Переводы между счетами внутри депозитария осуществляются без комиссии',
        'Withdraw': 'Вывести',
        'Depository address to transfer': 'Номер счета для перевода',
        'Wallet address': 'Адрес кошелька',
        'How much': 'Сколько',
        'Transfers between depositories': 'Переводы между депозитариями без комиссии',
        'Send': 'Отправить',
        'Wallet': 'Кошелек',
        'Wallet-balance': 'Баланс',
        'Wallet is': 'Кошелек',
        'Wallet is  a cryptocurrency': ' - сервис управления вашим криптовалютным портфелем, позволяющий получать, хранить и отправлять различные монеты и токены. Список поддерживаемых валют постоянно расширяется.',
        'Frequent questions': 'Частые вопросы',
        'How to transfer money to your wallet?': 'Как перевести деньги на свой кошелек?',
        'How buy CPT?': 'Как купить CPT?',
        'How withdraw money?': 'Как вывести деньги?',
        'How to use apps?': 'Как использовать приложения?',
        'See all': 'Посмотреть все',
        'Total': 'Всего',
        'operation failed': 'Операция не выполнена',
        'operation completed successfully': 'Операция успешно завершена',
        'address': 'адрес',
        'To receive a transfer': 'Чтобы получить перевод, сообщите этот адрес отправителю. Отправлять на него можно только',
        "coins can be sent to it":"",
        "tokens can be sent to it":"",
        "mosaics can be sent to it":"",
        'Copy': 'Копировать',
        'Copied': 'Скопировано',
        'To send put': 'Чтобы отправить',
        'coins enter': ', введите',
        'mosaics enter': ', введите',
        'tokens enter': ', введите',
        'wallet address or name': 'адрес получателя',
        'How much send': 'Укажите количество отправляемых',
        'tokens':'токенов',
        'coins':'монет',
        'mosaics':'мозаик',
        'token':'токены',
        'coin':'монеты',
        'mosaic':'мозаику',
        'coins to be sent': '',
        'tokens to be sent': '',
        'mosaics to be sent': '',
        'FAQ': 'FAQ',
        'How can I send CPTs': 'Как я могу отправить CPT с моего кошелька Cryptaur на другой кошелек?',
        'Where can I purchase CPT tokens?': 'Где я могу купить токены CPT?',
        'How to change the two-factor': 'Как изменить двухфакторную аутентификацию с адреса электронной почты на SMS-уведомление на панели пользователя (и наоборот)?',
        'Why are CPT tokens displayed': 'Почему токены CPT отображаются на панели инструментов, а токены Cryptaur недоступны на балансе счета внутреннего кошелька Cryptaur Ether? Что мне нужно сделать, чтобы получить токены?',
        'What is this statement': 'Для чего это утверждение «Отправки токенов из внутреннего Cryptaur Ether Wallet (CEW) в кошелек с другим адресом»?',
        'What does the phrase': 'Что означает фраза «кошелек, поддерживающий токены, совместимые с ERC20»?',
        'What does the phrase wallet': 'Что означает фраза «кошелек, который не принадлежит обмену или обменному пункту»?',
        'What is the future price of CPT?': 'Какая цена CPT будет в будущем?',
        'Where do I find information': 'Где я могу найти информацию о проекте Prover?',
        'To contact Cryptaur Support': 'Связаться со службой поддержки Cryptaur',
        'write to our': 'напишите в наш',
        'chat': 'чат',
        'or e-mail': 'или e-mail',
        'Cryptaur wallet authorization': 'Авторизация Cryptaur',
        'Password': 'Пароль',
        'Password recovery': 'Восстановление пароля',
        'Restore': 'Восстановить',
        'Registration': 'Регистрация',
        'First name': 'Имя',
        'Last name': 'Фамилия',
        'Must be more': 'Должно быть более',
        'than 6 symbols': '6 символов',
        'I agree to the': 'Я согласен с',
        'terms and conditions': 'условиями пользования',
        'Register': 'Регистрация',
        'Bonus': 'Бонусы',
        'Dashboard': 'Панель управления',
        'Login': 'Вход',
        'Logout': 'Выход',
        'Forgot your password?': 'Забыли пароль?',
        'Haven’t registered yet?': 'Не зарегистрировались?',
        'Improve': 'Улучшить',
        'my activity in': 'моя активность в',
        "january": "январе",
        "february": "феврале",
        "march": "марте",
        "april": "апреле",
        "may": "мае",
        "june": "июне",
        "july": "июле",
        "august": "августе",
        "september": "сентябре",
        "october": "октябре",
        "november": "ноябре",
        "december": "декабре",
        "Message": "Поле Сообщение является опциональным, но, как правило, при отправке на биржу его требуется заполнять всегда, иначе отправленные средства будут потеряны",
        "Enter the correct address": "Введите корректный адрес",
        "Enter an amount greater than 0": "Введите сумму больше 0",
        "Settings": "Настройки",
        "Firstname": "Имя",
        "Lastname": "Фамилия",
        "Patronymic": "Отчество",
        "Gender": "Пол",
        "Email": "Почта",
        "Phone": "Телефон",
        "Passport": "Паспорт",
        "Series number": "Серия и номер",
        "Date issue": "Дата выдачи",
        "Country": "Страна",
        "City": "Город",
        "Address": "Адрес",
        "Postal code": "Индекс",
        "Referrer code": "Реферальный код",
        "E-passport": "Е-паспорт",
        "Coming soon": "Скоро",
        "Unknown": "Неизвестно",
        "Man": "Мужчина",
        "Woman": "Женщина",
        "edit": "изменить",
        "save": "сохранить",
        "new password": "новый пароль",
        "next": "далее",
        "Enter current password": "Введите текущий пароль",
        "Enter new password": "Введите новый пароль",
        "Your data is protected": "Ваши данные защищены",
        "Your data is protected by two-factor authentication": "Ваши данные защищены",
        "Your data is not protected by two-factor authentication": "Ваши данные не защищены",
        "Type of two-factor authentication": "Тип двухфакторной аутентификации",
        "Click to change": "Нажмите, чтобы изменить",
        "Connect": "Подключить",
        "Get code": "Получить код",
        "Check": "Проверить",
        "Select type…": "Выбранный тип…",
        "Close": "Закрыть",
        "Set Up two-factor authentication with Google Authenticator": "Настройка двухфакторной аутентификации с Google Authenticator",
        "After installing the Google Authenticator app scan the QR code below and enter the verification code you see in the Google Authenticator App": "После установки приложения Google Authenticator отсканируйте QR-код ниже и введите проверочный код, который вы видите в приложении Google Authenticator",
        "Secret code": "Секретный код",
        "Select the type of two-factor authentication": "Выберите тип двухфакторной аутентификации",
        "Selected type of two-factor authentication": "Выбранный тип двухфакторной аутентификации ",
        "Enter the current code": "Введите текущий код",
        "Enter the received code": "Введите полученный код",
        "Enter the code": "Ввести код",
        "Current type of two-factor authentication": "Текущий тип двухфакторной аутентификации",
        "AgeHack allows you to monitor your health and receive the necessary recommendations in time to strengthen it": "AgeHack позволяет следить за здоровьем и вовремя получать необходимые рекомендации.",
        "Message size exceeds maximum size": "Размер сообщения превышает максимальный размер",
        "You don't have enough money to pay for this transaction.": "У вас недостаточно токенов для оплаты этой транзакции.",
        "Already exist": "Email уже существует",
        "Email not valid": "Некорректный email",
        "Referrer not exist": "Реферальный код указан неверно",
        "Password not pass requirements": "Пароль не соответствует требованиям",
        "Send mail problem": "Проблема отправки почты",
        "You have successfully registered": "Пользователь успешно зарегистрирован. На указанный E-mail адрес было отправлено письмо. Пожалуйста, подтвердите регистрацию.",
        "Wrong captcha": "Неверная каптча",
        "Not registered": "Пользователь с указанным Email не зарегистрирован",
        "An letter has been sent to the specified email address": "На ваш email было отправлено письмо с новым паролем. Он начнет действовать после перехода по ссылке, отправленной в том же письме.",
        "Investor unavailable": "Инвестор заблокирован",
        "Reached attempts limit, wait a minute": "Исчерпан лимит попыток, подождите минуту",
        "Wrong credentials": "Неверные данные",
        "Commission calculation error": "Не удалось рассчитать комиссию",
        "Not enough money to pay commission": "Недостаточно средств для оплаты комиссии",
        "Some text here":"Здесь какой то текст",
        "Site":"Сайт",
        "Play":"Играть",
        "About":"Описание",
        "See catalog":"Каталог",
        "LifeWise about":"Уникальный p2p маркетплейс, где любой желающий может приобрести товары непосредственно у поставщика без каких-либо посредников.",
        "Games about":"Полностью регулируемая игровая платформа, основанная на технологии блокчейн.",
        "Prover about":"Технология подтверждения подлинности созданных пользователем видеофайлов.",
        "Socium about":"Социальная сеть, где происходят выборы Экспертов, верификация поставщиков и рассмотрение новых товаров для LifeWise.",
        "X-Game about":"Блокчейн игра, в основе которой лежит универсальная генетическая лаборатория.",
        "Mendel Chess about":"Играйте в шахматы фигурами, полученными в результате скрещивания в специальной лаборатории.",
        "Etherdragons Arena about":"Выращивайте своих драконов, прокачивай их и отправляй сражаться на арену с другими игроками.",
        "Crowd Filming about":"Crowd Filming это сервис совместной съемки и сведения пользовательских видео в крутые сборные клипы.",
        "More": "Ещё",
        "Enter Two-Factor authentication code": "Введите код двухфакторной аутентификации",
        "You need to confirm the changes of some items using two-factor authentication. Currently, the changed items are saved locally.": "Необходимо подтвердить изменения некоторых элементов с помощью двухфакторной аутентификации. В настоящее время измененные элементы сохранены локально.",
        "Confirm": "Подтвердить",
        "Number of changed items": "Количество изменений",
        "You have changed items": "Данные изменены",
        "Confirm new phone number": "Подтверждение номера",
        "need to configure two-factor authentication":"Необходимо настроить двухфакторную аутентификацию",
        "copy code": "скопировать код",
        "copy link": "скопировать ссылку",
        "Copy link": "Скопировать ссылку",
        "session is out of date": "Сессия устарела",
        "fill this field": "Заполните это поле",
        "check this box to continue": "Чтобы продолжить, установите этот флажок",
        'sent to Email': 'отправленный на Email',
        'sent by SMS': 'отправленный через SMS',
        'from the Google Authenticator app': 'из приложения Google Authenticator',
        'Two-factor authentication type': 'Тип двухфакторной аутентификации',
        'To display data, enter the code': 'Для отображения данных, введите код',
        'Wrong code': 'Неправильный код',
        'Sent the code to your email': 'На Ваш электронный адрес отправлен код',
        'Sent the code to your phone number':'На Ваш телефон отправлено SMS',
        'Two-factor authorization code': 'Код двухфакторной авторизации',
        'You will need to confirm with two-factor authentication': 'Изменения необходимо подтвердить двухфакторной аутентификацией',
        'Get SMS with code': 'Получить СМС с кодом',
        'Your changes are saved': 'Ваши изменения сохранены',
        'Profile': 'Профиль',
        'Contacts': 'Контакты',
        'Change password': 'Изменение пароля',
        'Passport': 'Паспорт',
        'Two-factor authentication': 'Двухфакторная аутентификация',
        'ePassport': 'ePassport',
        'Current password': 'Текущий пароль',
        'New password': 'Новый пароль',
        'Remove': 'Удалить',
        'dApp info': 'Информация о dApp',
        'Key': 'Ключ',
        'Set a password for the key': 'Установить пароль для ключа',
        'Enter the 2FA code': 'Введите код 2FA',
        'EPassport about': 'Предназначен для автоматизированного предоставления пользовательских данных приложениям Cryptaur.',
        'Get into': 'Перейти',
        'Your depository': 'Ваш депозитарий',
        'Please login before continue': 'Пожалуйста, войдите перед продолжением',
        'Description': 'Описание',
        'Order ID': 'Идентификатор заказа',
        'balance': 'баланс',
        'Continue': 'Продолжить',
        'Refuse': 'Отклонить',
        'Success': 'Успех',
        'Error': 'Ошибка',
        'The payment is successfully complete': 'Платеж успешно завершен',
        'Payment ID is incorrect': 'Неверно указан идентификатор платежа',
        'Invalid recipient': 'Неверно указан получатель',
        'Invalid payment amount': 'Неверно указана сумма к переводу',
        'Incorrect currency': 'Неверно указана валюта',
        'Incorrect description': 'Неверно указано описание',
        'Invalid URL Path for success': 'Неверно указан адрес страницы для случая успеха',
        'Invalid URL Path for fail': 'Неверно указан адрес страницы для случая ошибки',
        'Select the type of two-factor authentication': 'Выберите тип двухфакторной аутентификации',
        'The type of two-factor authentication is not specified': 'Не указан тип двухфакторной аутентификации',
    },
    'en': {
        'Depository': 'Depository',
        'Deposit from my Wallet': 'Deposit from my Wallet',
        'Deposit from another Depository': 'Transfer from another participant',
        'Withdraw to my Wallet': 'Withdrawal to my wallet',
        'Send to another Depository': 'Send another participant',
        'Buy CPT': 'Buy CPT',
        'Depository is': 'Depository',
        'Depository is internal Cryptaur': ' is a special account in the Cryptaur system that allows no-fee paying for goods and services within the ecosystem, to exchange tokens with other participants, and also to receive rewards and bonuses.',
        'Payments in app': 'Each transaction is committed to Cryptaur Blockchain.',
        'Transactions do not reflect': 'Depository replenishment from the balance of your Wallet and withdrawal of tokens back to the Wallet requires transaction payment in the Ethereum network.',
        'History': 'History',
        'Show all transactions': 'Show all transactions',
        'Enter two-factor': 'Please, enter two-factor authentication code',
        'Deposit': 'Deposit',
        'Is in your wallet': 'Is in your wallet',
        'Maximum amount available for deposit': 'Maximum amount available for deposit',
        'The cost per transaction': 'The cost per transaction',
        'You have': 'You have',
        'ETH in your wallet': 'ETH in your wallet',
        'Send the address': 'To receive the transfer provide your account number to the sender.',
        'He or she needs': 'Inform the sender that transfer to this account number is possible only through the Depositary tab in the personal account!',
        'Transfers between depositories without commission': 'Transfers between accounts within the depositary are made without fees',
        'Withdraw': 'Withdraw',
        'Depository address to transfer': 'Account number for transfer',
        'Wallet address': 'Wallet address',
        'How much': 'How much',
        'Transfers between depositories': 'Transfers between depositories without commission',
        'Send': 'Send',
        'Wallet': 'Wallet',
        'Wallet-balance': 'Wallet',
        'Wallet is': 'Wallet',
        'Wallet is  a cryptocurrency': ' is a service for managing your cryptocurrency portfolio that allows you to receive, store and send various coins and tokens. The list of supported currencies is constantly expanding.',
        'Frequent questions': 'Frequent questions',
        'How to transfer money to your wallet?': 'How to transfer money to your wallet?',
        'How buy CPT?': 'How buy CPT?',
        'How withdraw money?': 'How withdraw money?',
        'How to use apps?': 'How to use apps?',
        'See all': 'See all',
        'Total': 'Total',
        'operation failed': 'Operation failed',
        'operation completed successfully': 'Operation completed successfully',
        'address': 'address',
        'To receive a transfer': 'To receive a transfer please provide this address to the sender. Only',
        "coins can be sent to it":"сoins can be sent to it.",
        "tokens can be sent to it":"tokens can be sent to it.",
        "mosaics can be sent to it":"mosaics can be sent to it.",
        'Copy': 'Copy',
        'Copied': 'Copied',
        'To send put': 'To send',
        'coins enter':' coins enter',
        'mosaics enter':' mosaics enter',
        'tokens enter':' tokens enter',
        'wallet address or name': 'the address of the recipient.',
        'How much send': 'Enter the number of',
        'token':'',
        'coin':'',
        'mosaic':'',
        'tokens':'',
        'coins':'',
        'mosaics':'',
        'coins to be sent': 'coins to be sent.',
        'tokens to be sent': 'tokens to be sent.',
        'mosaics to be sent': 'mosaics to be sent.',
        'FAQ': 'FAQ',
        'How can I send CPTs': 'How can I send CPTs from my Cryptaur wallet to another wallet?',
        'Where can I purchase CPT tokens?': 'Where can I purchase CPT tokens?',
        'How to change the two-factor': 'How to change the two-factor authentication from an Email address to an  SMS-notification in the user’s Dashboard (and vice versa)?',
        'Why are CPT tokens displayed': 'Why are CPT tokens displayed in the Dashboard, while no Cryptaur tokens are available in the account balance of the internal Cryptaur Ether Wallet? What do I have to do to get the tokens?',
        'What is this statement': 'What is this statement for "Sending tokens from the internal Cryptaur Ether Wallet (CEW) to a wallet with a different address"?',
        'What does the phrase': 'What does the phrase "wallet that supports ERC20-compliant tokens" mean?',
        'What does the phrase wallet': 'What does the phrase "a wallet that does not belong to an exchange or an exchange office" mean?',
        'What is the future price of CPT?': ' What is the future price of CPT?',
        'Where do I find information': 'Where do I find information about the Prover project?',
        'To contact Cryptaur Support': 'To contact Cryptaur Support',
        'write to our': 'write to our',
        'chat': 'chat',
        'or e-mail': 'or e-mail',
        'Cryptaur wallet authorization': 'Cryptaur wallet authorization',
        'Password': 'Password',
        'Password recovery': 'Password recovery',
        'Restore': 'Restore',
        'Registration': 'Registration',
        'First name': 'First name',
        'Last name': 'Last name',
        'Must be more': 'Must be more',
        'than 6 symbols': 'than 6 symbols',
        'I agree to the': 'I agree to the',
        'terms and conditions': 'terms and conditions',
        'Register': 'Register',
        'Bonus': 'Bonus',
        'Dashboard': 'Dashboard',
        'Login': 'Login',
        'Logout': 'Logout',
        'Forgot your password?': 'Forgot your password?',
        'Haven’t registered yet?': 'Haven’t registered yet?',
        'Improve': 'Improve',
        'my activity in': 'my activity in',
        "january": "january",
        "february": "february",
        "march": "march",
        "april": "april",
        "may": "may",
        "june": "june",
        "july": "july",
        "august": "august",
        "september": "september",
        "october": "october",
        "november": "november",
        "december": "december",
        "Message": "The Message field is optional, but, as a rule, it should always be filled  when sending to the blockchain; otherwise the sent funds will be lost.",
        "Enter the correct address": "Enter the correct address",
        "Enter an amount greater than 0": "Enter an amount greater than 0",
        "Settings": "Settings",
        "Firstname": "Firstname",
        "Lastname": "Lastname",
        "Patronymic": "Patronymic",
        "Gender": "Gender",
        "Email": "Email",
        "Phone": "Phone",
        "Passport": "Passport",
        "Series number": "Series number",
        "Date issue": "Date issue",
        "Country": "Country",
        "City": "City",
        "Address": "Address",
        "Postal code": "Postal code",
        "Referrer code": "Referrer code",
        "Coming soon": "Coming soon",
        "Unknown": "Unknown",
        "Man": "Man",
        "Woman": "Woman",
        "edit": "edit",
        "save": "save",
        "new password": "new password",
        "next": "next",
        "Enter current password": "Enter current password",
        "Enter new password": "Enter new password",
        "Your data is protected": "Your data is protected",
        "Your data is protected by two-factor authentication": "Your data is protected by two-factor authentication",
        "Your data is not protected by two-factor authentication": "Your data is not protected by two-factor authentication",
        "Type of two-factor authentication": "Type of two-factor authentication",
        "Click to change": "Click to change",
        "Connect": "Connect",
        "Get code": "Get code",
        "Check": "Check",
        "Select type…": "Select type…",
        "Close": "Close",
        "Set Up two-factor authentication with Google Authenticator": "Set Up two-factor authentication with Google Authenticator",
        "After installing the Google Authenticator app scan the QR code below and enter the verification code you see in the Google Authenticator App": "After installing the Google Authenticator app scan the QR code below and enter the verification code you see in the Google Authenticator App",
        "Secret code": "Secret code",
        "Select the type of two-factor authentication": "Select the type of two-factor authentication",
        "Selected type of two-factor authentication": "Selected type of two-factor authentication",
        "Enter the current code": "Enter the current code",
        "Enter the code": "Enter the code",
        "Enter the received code": "Enter the received code",
        "Current type of two-factor authentication": "Current type of two-factor authentication",
        "AgeHack allows you to monitor your health and receive the necessary recommendations in time to strengthen it": "AgeHack allows you to monitor your health and receive the necessary recommendations.",
        "Message size exceeds maximum size": "Message size exceeds maximum size",
        "You don't have enough money to pay for this transaction.": "You don't have enough tokens to pay for this transaction.",
        "Already exist": "Already exist",
        "Email not valid": "Email not valid",
        "Referrer not exist": "Referrer not exist",
        "Password not pass requirements": "Password not pass requirements",
        "Send mail problem": "Send mail problem",
        "You have successfully registered": "User registered successfully. An email has been sent to the specified E-mail address. Please confirm registration.",
        "Wrong captcha": "Wrong captcha",
        "Not registered": "Not registered",
        "An letter has been sent to the specified email address": "An email with a new password has been sent to your email. It will take effect after clicking on the link sent in the same letter.",
        "Investor unavailable": "Investor unavailable",
        "Reached attempts limit, wait a minute": "Reached attempts limit, wait a minute",
        "Wrong credentials": "Wrong credentials",
        "Commission calculation error": "Commission calculation error",
        "Not enough money to pay commission": "Not enough money to pay commission",
        "Some text here":"Some text here",
        "Site":"Site",
        "Play":"Play",
        "About":"About",
        "See catalog":"See catalog",
        "LifeWise about":"It is a unique p2p marketplace where anyone can purchase products directly from a vendor without any intermediaries.",
        "Socium about":"It is the social network in which Experts are elected, vendors are verified and new products are reviewed for LifeWise.",
        "X-Game about":"X-Game is a blockchain game based on a universal genetic laboratory.",
        "Mendel Chess about":"Play chess with pieces, obtained by crossing the basic ones in a special laboratory.",
        "Etherdragons Arena about":"Grow your own dragons, grind them and send them to the arena to fight against other players.",
        "Crowd Filming about":"Crowd Filming is an online service for capturing personal videos into collective automated clips.",
        "Games about":"It is a fully regulated gambling platform based on blockchain technology.",
        "Prover about":"Technology of authenticity verification of user generated video files.",
        "More": "More",
        "Enter Two-Factor authentication code": "Enter Two-Factor authentication code",
        "You need to confirm the changes of some items using two-factor authentication. Currently, the changed items are saved locally.": "You need to confirm the changes of some items using two-factor authentication. Currently, the changed items are saved locally.",
        "Confirm": "Confirm",
        "Number of changed items": "Number of changed items",
        "You have changed items": "You have changed items",
        "Confirm new phone number": "Confirm new phone number",
        "need to configure two-factor authentication":"Need to configure two-factor authentication",
        "copy code": "copy code",
        "copy link": "copy link",
        "Copy link": "Copy link",
        "session is out of date": "Session is out of date",
        "fill this field": "Fill this field",
        "check this box to continue": "Сheck this box to continue",
        'sent to Email': 'sent to Email',
        'sent by SMS': 'sent by SMS',
        'from the Google Authenticator app': 'from the Google Authenticator app',
        'Two-factor authentication type': 'Two-factor authentication type',
        'To display data, enter the code': 'To display data, enter the code',
        'Wrong code': 'Wrong code',
        'Sent the code to your email': 'Sent the code to your email',
        'Sent the code to your phone number': 'Sent the code to your phone number',
        'Two-factor authorization code': 'Two-factor authorization code',
        'You will need to confirm with two-factor authentication': 'You will need to confirm with two-factor authentication',
        'Get SMS with code': 'Get SMS with code',
        'Your changes are saved': 'Your changes are saved',
        'Profile': 'Profile',
        'Contacts': 'Contacts',
        'Change password': 'Change password',
        'Passport': 'Passport',
        'Two-factor authentication': 'Two-factor authentication',
        'ePassport': 'ePassport',
        'Current password': 'Current password',
        'New password': 'New password',
        'Remove': 'Remove',
        'dApp info': 'dApp info',
        'Key': 'Key',
        'Set a password for the key': 'Set a password for the key',
        'Enter the 2FA code': 'Enter the 2FA code',
        'EPassport about': 'Designed for automated providing of user data to Cryptaur applications.',
        'Get into': 'Get into',
        'Your depository': 'Your depository',
        'Please login before continue': 'Please login before continue',
        'Description': 'Description',
        'Order ID': 'Order ID',
        'balance': 'balance',
        'Continue': 'Continue',
        'Refuse': 'Refuse',
        'Success': 'Success',
        'Error': 'Error',
        'The payment is successfully complete': 'The payment is successfully complete',
        'Payment ID is incorrect': 'Payment ID is incorrect',
        'Invalid recipient': 'Invalid recipient',
        'Invalid payment amount': 'Invalid payment amount',
        'Incorrect currency': 'Incorrect currency',
        'Incorrect description': 'Incorrect description',
        'Invalid URL Path for success': 'Invalid URL Path for success',
        'Invalid URL Path for fail': 'Invalid URL Path for fail',
        'Select the type of two-factor authentication': 'Select the type of two-factor authentication',
        'The type of two-factor authentication is not specified': 'The type of two-factor authentication is not specified',
    }
}
